export interface EventsResponse {
  events: Event[];
  count:  number;
}

export interface Event {
  address: Address;
  allDay: boolean;
  cancelled: boolean;
  category: string;
  description: string;
  end: End;
  enrolement: boolean;
  excerpt?: string;
  featured: boolean;
  geo: Geo;
  image: string;
  location: Location;
  otherInfo: string;
  start: End;
  subcategories: string[];
  title: string;
  id: number;
  url?: string;
  action?: Action;
}

export interface Address {
  country: Country;
  locality: Locality;
  postalCode: string;
  region: Region;
  streetAddress: string;
}

export interface Action {
  type: string;
  url: string;
}

export type Locality = 'The Villages';
export type Country = 'US' | '';
export type Region = "FL" | "";

export interface End {
  date: Date;
  type: EndType;
}

export type EndType = "time";

export interface Geo {
  type:        GeoType;
  coordinates: number[];
}

export type GeoType = "Point";

export interface Location {
  id:         string;
  title:      string;
  category?:  string;
  complexId?: string;
  image:      string;
}

// Converts JSON strings to/from your types
export class EventsResponseConverter {
  public static toEventsResponse(json: string): EventsResponse {
    return JSON.parse(json);
  }

  public static eventsResponseToJson(value: EventsResponse): string {
    return JSON.stringify(value);
  }
}
